import Fade from '@mui/material/Fade';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
// import { useState } from 'react';
// import { ToggleChip } from './ToggleChip';
import { InfoChip } from './InfoChip';
import { useRentalChips } from 'src/hooks/useRentalChips';
import { useMobile } from 'src/contexts/useMobile';

export type RentalChipsProps = {
  hoursMax: number;
  hoursMin?: number;
  royalty?: number;
  rentedUntil?: Date;
  showAsWhitelisted: boolean;
  forTournaments?: boolean;
};

export const RentalChips = ({
  hoursMax,
  hoursMin = 1,
  royalty = 0,
  rentedUntil = undefined,
  showAsWhitelisted,
  forTournaments = false,
}: RentalChipsProps) => {
  // const [hovered, setHovered] = useState(false);
  const { chips } = useRentalChips({
    hoursMax,
    hoursMin,
    rentedUntil,
    royalty,
    forTournaments,
  });
  const isMobile = useMobile();
  return (
    <Stack
      // direction={hovered ? 'row-reverse' : 'row'}
      direction={'row-reverse'}
      flexWrap="wrap"
      alignItems="center"
      justifyContent={'flex-start'}
      // justifyContent={hovered ? 'flex-start' : 'flex-end'}
      sx={{
        position: 'absolute',
        zIndex: 1,
        top: 12,
        width: isMobile ? 'calc(100% - 16px)' : 'calc(100% - 12px)',
      }}
      gap={1}
      // onMouseLeave={() => setHovered(false)}
    >
      {/* TODO: Reintroduce hover if required */}
      {/* {!currentlyRented ? (
        <Box onMouseEnter={() => setHovered(true)}>
          <ToggleChip open={hovered} />
        </Box>
      ) : null} */}
      {/* TODO: reintroduce !!currentlyRented || hovered */}
      {chips.map((infoChip, index) => (
        <Fade
          in={true}
          key={infoChip.label}
          style={{ transitionDelay: `${index * 20}ms` }}
        >
          <Box>
            <InfoChip {...infoChip} showAsWhitelisted={showAsWhitelisted} />
          </Box>
        </Fade>
      ))}
    </Stack>
  );
};
